"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.copyPrivateArea = copyPrivateArea;
exports.deletePrivateArea = deletePrivateArea;
exports.getBonusRuleList = getBonusRuleList;
exports.getChannelList = getChannelList;
exports.getCouponPackagesWithItems = getCouponPackagesWithItems;
exports.getPrivateAreaDetail = getPrivateAreaDetail;
exports.getPrivateAreaList = getPrivateAreaList;
exports.savePrivateArea = savePrivateArea;
exports.togglePrivateAreaStatus = togglePrivateAreaStatus;
exports.uploadPrivateAreaImage = uploadPrivateAreaImage;
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
var _requestAuth = _interopRequireDefault(require("@/utils/requestAuth"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * 获取私域领券列表（复用优惠券发放接口，传递event=4）
 * @param {Object} query - 查询参数
 */
function getPrivateAreaList(query) {
  // 传递 event=4 只查询私域领券类型
  var params = _objectSpread(_objectSpread({}, query), {}, {
    event: 4
  });
  return (0, _requestAuth.default)({
    url: '/bonusSend/list',
    method: 'get',
    params: params
  });
}

/**
 * 获取私域领券详情（复用优惠券发放接口）
 * @param {Number} id - 发放ID
 */
function getPrivateAreaDetail(id) {
  return (0, _requestAuth.default)({
    url: "/bonusSend/".concat(id),
    method: 'get'
  });
}

/**
 * 保存私域领券（复用优惠券发放接口）
 * @param {Object} data - 发放数据
 */
function savePrivateArea(data) {
  // 强制设置 event 为 4（私域领券）
  var submitData = _objectSpread(_objectSpread({}, data), {}, {
    event: 4
  });
  return (0, _requestAuth.default)({
    url: '/bonusSend',
    method: 'post',
    data: submitData
  });
}

/**
 * 删除私域领券（复用优惠券发放接口）
 * @param {Number} id - 发放ID
 */
function deletePrivateArea(id) {
  return (0, _requestAuth.default)({
    url: "/bonusSend/".concat(id),
    method: 'delete'
  });
}

/**
 * 复制私域领券活动（复用优惠券发放接口）
 * @param {Number} id - 发放ID
 */
function copyPrivateArea(id) {
  return (0, _requestAuth.default)({
    url: "/bonusSend/copy/".concat(id),
    method: 'post'
  });
}

/**
 * 启用/禁用私域领券（复用优惠券发放接口）
 * @param {Number} id - 发放ID
 * @param {Number} val - 状态值
 * @param {String} field - 字段名（enabled或canShare）
 */
function togglePrivateAreaStatus(id, val) {
  var field = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'enabled';
  return (0, _requestAuth.default)({
    url: "/bonusSend/toggleStatus/".concat(id),
    method: 'post',
    data: (0, _defineProperty2.default)({}, field, val)
  });
}

/**
 * 获取所有有效券包及其明细
 */
function getCouponPackagesWithItems() {
  return (0, _requestAuth.default)({
    url: '/couponPackage/listEnabledWithItems',
    method: 'get'
  });
}

/**
 * 获取套券规则列表
 */
function getBonusRuleList() {
  return (0, _requestAuth.default)({
    url: '/bonusSend/bonusRules',
    method: 'get'
  });
}

/**
 * 获取渠道列表
 */
function getChannelList() {
  return (0, _requestAuth.default)({
    url: '/bonusSend/channels',
    method: 'get'
  });
}

/**
 * 上传图片
 * @param {File} file - 图片文件
 */
function uploadPrivateAreaImage(file) {
  var formData = new FormData();
  formData.append('file', file);
  return (0, _requestAuth.default)({
    url: '/bonusSend/uploadImage',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}